import React from "react";
import { Container } from "react-bootstrap";

import classNames from "classnames";

import PageContent from "./components/PageContent";
import PageHeader from "./components/PageHeader";
import {
    ScheduleActionsProvider,
    useScheduleActionsContext,
} from "./contexts/ScheduleActions";

import Loading from "../../../../components/Loading";

const ScheduleActions = (): React.JSX.Element => {
    return (
        <div
            data-testid="scheduleActionsContent"
            className="scheduleActionsContent"
        >
            <Container>
                <ScheduleActionsProvider>
                    <Loading
                        className={classNames({
                            "position-fixed": true,
                            "bottom-0": true,
                            "start-0": true,
                            "m-3": true,
                        })}
                        useContext={useScheduleActionsContext}
                    />
                    <PageHeader />
                    <PageContent />
                </ScheduleActionsProvider>
            </Container>
        </div>
    );
};

export default ScheduleActions;
